import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { RoutesKeys } from 'src/app/utils/routes';
import { MatSelectChange } from '@angular/material/select';
import { ProductService } from 'src/app/core/api/product/product.service';

@Component({
  selector: 'app-products-container',
  templateUrl: './products-container.component.html',
  styleUrls: ['./products-container.component.scss'],
})
/**
 * Products container component
 */
export class ProductsContainerComponent implements OnInit {
  labels = {
    productList: 'product-list',
    addParticipatingProduct: 'add-participating-product',
    selectPlaceholder: 'select-series-placeholder',
  };
  availableFamily: any[] = [{ label: 'All', value: 'all' }];
  selectedFamily: any;

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private productService: ProductService,
    private router: Router
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.getFamily();
  }

  /**
   * Navigates to the product edit page
   */
  goToProductEdit(): void {
    this.router.navigate([RoutesKeys.PRODUCT_DETAIL]);
  }

  /**
   * Change the select family
   * @param {MatSelectChange} event
   */
  changeFamily(event: MatSelectChange): void {
    this.selectedFamily = event.value;
  }

  /**
   * Method to get all family from de system
   */
  getFamily(): void {
    this.productService.getAllFamilyProduct().subscribe({
      next: (family) => {
        this.availableFamily = [
          ...this.availableFamily,
          ...family.map((item) => ({
            label: item.name,
            value: item.id,
          })),
        ];
      },
    });
  }
}
